// src/lib/img.js
//
// Turns a single source image path (e.g. "./Semester_6/Umgebung.webp") into the
// responsive variants produced by scripts/optimize-images.mjs, plus a correctly
// encoded `srcSet` string so the browser downloads the smallest file that fits.
//
// Paths may contain spaces ("Umgebung Kopie.webp"). In a srcSet the space is the
// delimiter between URL and width descriptor, so each URL must be encoded.

const WIDTHS = [400, 800, 1600];

// Encode each path segment (spaces -> %20) while keeping the slashes intact.
function encodePath(p) {
  return p
    .split("/")
    .map((seg) => encodeURIComponent(seg))
    .join("/");
}

/**
 * @param {string} src - original path, e.g. "./Semester_6/Umgebung.webp"
 * @param {number[]} [widths]
 * @returns {{ thumb: string, mid: string, full: string, srcSet: string, original: string }}
 */
export function imgSet(src, widths = WIDTHS) {
  if (!src) return { thumb: "", mid: "", full: "", srcSet: "", original: "" };

  const dot = src.lastIndexOf(".");
  const base = dot === -1 ? src : src.slice(0, dot);
  const ext = dot === -1 ? "" : src.slice(dot);
  const variant = (w) => `${base}-${w}${ext}`;

  const srcSet = widths
    .map((w) => `${encodePath(variant(w))} ${w}w`)
    .join(", ");

  return {
    thumb: encodePath(variant(widths[0])),
    mid: encodePath(variant(widths[Math.min(1, widths.length - 1)])),
    full: encodePath(variant(widths[widths.length - 1])),
    srcSet,
    original: encodePath(src),
  };
}
